import { TuiTabBarModule } from '@taiga-ui/addon-mobile';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { IfHasPermissionPipe } from '@iss/libs/auth';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { Component, inject } from '@angular/core';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';

import { PageMobileNavTabBarItemComponent } from './page-mobile-nav-tab-bar-item';

import { AppRoutingLinks, AppRoutingPaths } from '@wo-mc/routing';
import { appContextFeature } from '@wo-mc/+state';

@Component({
  selector: 'wo-page-mobile-tab-bar',
  templateUrl: './page-mobile-app-tab.component.html',
  styleUrls: [ './page-mobile-app-tab.component.scss' ],
  standalone: true,
  imports: [
    AsyncPipe,
    NgForOf,
    NgIf,
    PageMobileNavTabBarItemComponent,
    RouterLink,
    RouterLinkActive,
    TranslateModule,
    TuiTabBarModule,
    IfHasPermissionPipe,
  ],
})
export class PageMobileAppTabComponent {
  private readonly store = inject(Store);

  public readonly AppRoutingPaths = AppRoutingPaths;
  public readonly AppRoutingLinks = AppRoutingLinks;
  public readonly siteId$ = this.store.select(appContextFeature.selectSite);
  public readonly canSeeSwitchContext$ = this.store.select(appContextFeature.selectHasMultipleContexts);
}
